module.exports = __webpack_public_path__ + "static/img/info-left.74a67a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/info-left.png
// module id = YgOF
// module chunks = 1